import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MedalsService, UserMedal } from '../../services/medals.service';
import { MedalBadgeComponent } from '../medal-badge/medal-badge.component';

@Component({
  selector: 'app-user-name-medal',
  standalone: true,
  imports: [CommonModule, MedalBadgeComponent],
  template: `
    <span class="user-name-medal" [class.size-small]="size === 'small'" [class.size-large]="size === 'large'">
      <span class="user-name">{{ userName }}</span>
      <app-medal-badge [medal]="userMedal?.medal" *ngIf="userMedal && userMedal.active"></app-medal-badge>
    </span>
  `,
  styles: [`
    .user-name-medal {
      display: inline-flex;
      align-items: center;
      white-space: nowrap;
    }

    .user-name {
      display: inline-block;
    }

    /* Size variations */
    .size-small {
      font-size: 0.875rem;
    }

    .size-large {
      font-size: 1.25rem;
    }
  `]
})
export class UserNameMedalComponent implements OnInit, OnDestroy {
  @Input() userName: string = '';
  @Input() userId: string | null = null;
  @Input() size: 'small' | 'normal' | 'large' = 'normal';
  
  userMedal: UserMedal | null = null;
  private destroy$ = new Subject<void>();

  constructor(private medalsService: MedalsService) {}

  ngOnInit(): void {
    if (this.userId) {
      this.medalsService.getUserMedal(this.userId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(medal => {
          this.userMedal = medal;
        });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}